module.exports = __webpack_public_path__ + "static/media/greyjoy_power.c12e0fb9.png";